import { casOpsApi, CollectionModel, QueryTag, TagList } from '../api';
import { ModelWithId } from './commonModels';

export interface GeofenceHoldTimeModel extends ModelWithId {
  time: number; // seconds, 1 to 9999
  isGreater: boolean; // hold longer than (true), or hold less than (false)
  desc: string; // description (max 255 chars)
  used: boolean; // disable delete
}

export interface CreateGeofenceHoldTimeModel extends Omit<GeofenceHoldTimeModel, 'id' | 'used'> {}

export interface EditGeofenceHoldTimeModel extends Omit<GeofenceHoldTimeModel, 'id' | 'used'> {}

export interface GeofenceHoldTimeFormModel
  extends CreateGeofenceHoldTimeModel,
    EditGeofenceHoldTimeModel {}

export const geofenceHoldTimesApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    listGeofenceHoldTimes: build.query<GeofenceHoldTimeModel[], void>({
      query: () => 'api/geofencesettings/holdtimes',
      transformResponse: (response: CollectionModel<GeofenceHoldTimeModel>, meta, arg) =>
        response.items,
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.GeofenceHoldTime, id: TagList }] : [],
    }),
    getGeofenceHoldTime: build.query<GeofenceHoldTimeModel, ModelWithId>({
      query: ({ id }) => `api/geofencesettings/holdtimes/${id}`,
      providesTags: (result, error, { id }) =>
        result ? [{ type: QueryTag.GeofenceHoldTime, id: id }] : [],
    }),
    createGeofenceHoldTime: build.mutation<void, CreateGeofenceHoldTimeModel>({
      query: body => ({
        url: 'api/geofencesettings/holdtimes',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: QueryTag.GeofenceHoldTime, id: TagList }, QueryTag.GeofenceVersion],
    }),
    editGeofenceHoldTime: build.mutation<void, EditGeofenceHoldTimeModel & ModelWithId>({
      query: ({ id, ...body }) => ({
        url: `api/geofencesettings/holdtimes/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) =>
        !error
          ? [
              { type: QueryTag.GeofenceHoldTime, id: TagList },
              { type: QueryTag.GeofenceHoldTime, id: id },
              QueryTag.GeofenceVersion,
            ]
          : [],
    }),
    deleteGeofenceHoldTime: build.mutation<void, ModelWithId>({
      query: ({ id }) => ({
        url: `api/geofencesettings/holdtimes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { id }) =>
        !error
          ? [
              { type: QueryTag.GeofenceHoldTime, id: TagList },
              { type: QueryTag.GeofenceHoldTime, id: id },
              QueryTag.GeofenceVersion,
            ]
          : [],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListGeofenceHoldTimesQuery,
  useGetGeofenceHoldTimeQuery,
  useCreateGeofenceHoldTimeMutation,
  useEditGeofenceHoldTimeMutation,
  useDeleteGeofenceHoldTimeMutation,
} = geofenceHoldTimesApi;
